var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Handles Motomo Analytics events, enabling and disabling tracking.
 * */
import { Vue } from "vue-property-decorator";
var MotomoAnalytics = /** @class */ (function (_super) {
    __extends(MotomoAnalytics, _super);
    function MotomoAnalytics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Signal a single page view.
     * @param pagePath Path of the page.
     */
    MotomoAnalytics.pageView = function (pagePath, consentGiven) {
        var _paq = window._paq = window._paq || [];
        if (consentGiven) {
            _paq.push(['setConsentGiven']);
            var path = this.RemoveGuidFromPath(pagePath);
            _paq.push(['trackPageView', path]);
        }
    };
    MotomoAnalytics.RemoveGuidFromPath = function (pagePath) {
        return pagePath.replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/, 'id');
    };
    return MotomoAnalytics;
}(Vue));
export default MotomoAnalytics;
